import AccordionItem from './accordion-item/accordion-item.vue'
import Breadcrumb from './breadcrumb/breadcrumb.vue'
import Button from './button/button.vue'
import CategoryTag from './category-tag/category-tag.vue'
import CopyToClipboard from './copy-to-clipboard/copy-to-clipboard.vue'
import Col from './disposition/col.vue'
import Ct from './disposition/ct.vue'
import Row from './disposition/row.vue'
import Divider from './divider/divider.vue'
import Gradient from './gradient/gradient.vue'
import Image from './image/image.vue'
import Kicker from './kicker/kicker.vue'
import LinkItem from './link-item/link-item.vue'
import NtLoading from './nt-loading/nt-loading.vue'
import Overlay from './overlay/overlay.vue'
import Player from './player/player.vue'
import ScrollToTop from './scroll-to-top/scroll-to-top.vue'
import SocialIcons from './social-media-icons/social-media-icons.vue'
import Text from './text/text.vue'
import Title from './title/title.vue'
import Topic from './topic/topic.vue'
import TextWithIcon from './text-with-icon/text-with-icon.vue'
import TextWithSvgIcon from './text-with-svg-icon/text-with-svg-icon.vue'

export default [
  AccordionItem,
  Breadcrumb,
  Button,
  CategoryTag,
  CopyToClipboard,
  Col,
  Ct,
  Row,
  Divider,
  Gradient,
  Image,
  Kicker,
  LinkItem,
  NtLoading,
  Overlay,
  Player,
  ScrollToTop,
  SocialIcons,
  Text,
  Title,
  Topic,
  TextWithIcon,
  TextWithSvgIcon
]
